import { TFunction } from 'i18next';
import { OfferStatus } from '../types';

export function getColorFromOfferStatus(status: OfferStatus) {
  switch (status) {
    case 'pending':
      return 'warning';
    case 'published':
      return 'info';
    case 'accepted':
      return 'display';
    case 'rejected':
      return 'error';
    default:
      return 'default';
  }
}

export const formatedDate = (date: string, locale?: string) => new Date(date).toLocaleDateString(locale);

const BUYER_TYPE_LABELS: Record<string, string> = {
  'intermediary': 'Third-party representative: Acting on behalf of another buyer or entity.',
  'final-buyer': 'Final Buyer: Direct purchaser of the project and will hold ownership upon completion.',
  'debt-provider': 'Debt Provider: Financing party offering debt for the project; will not acquire ownership.',
};

export const getBuyerTypeLabel = (buyerType: string | undefined, t: TFunction): string | null => {
  const label = buyerType ? BUYER_TYPE_LABELS[buyerType] : undefined;
  return label ? t(label) : null;
};
